window.theme = window.theme || {}, window.home_video_list = window.home_video_list || {}, theme.Sections = function () {
    this.constructors = {}, this.instances = [], $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this))
}, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (b, f) {
        var g = $(b), j = g.attr('data-section-id'), k = g.attr('data-section-type');
        if (f = f || this.constructors[k], !_.isUndefined(f)) {
            var l = _.assignIn(new f(b), {id: j, type: k, container: b});
            this.instances.push(l)
        }
    }, _onSectionLoad: function (b) {
        var f = $('[data-section-id]', b.target)[0];
        f && this._createInstance(f)
    }, _onSectionUnload: function (b) {
        this.instances = _.filter(this.instances, function (f) {
            var g = f.id === b.originalEvent.detail.sectionId;
            return g && _.isFunction(f.onUnload) && f.onUnload(b), !g
        })
    }, _onSelect: function (b) {
        var f = _.find(this.instances, function (g) {
            return g.id === b.originalEvent.detail.sectionId
        });
        !_.isUndefined(f) && _.isFunction(f.onSelect) && f.onSelect(b)
    }, _onDeselect: function (b) {
        var f = _.find(this.instances, function (g) {
            return g.id === b.originalEvent.detail.sectionId
        });
        !_.isUndefined(f) && _.isFunction(f.onDeselect) && f.onDeselect(b)
    }, _onBlockSelect: function (b) {
        var f = _.find(this.instances, function (g) {
            return g.id === b.originalEvent.detail.sectionId
        });
        !_.isUndefined(f) && _.isFunction(f.onBlockSelect) && f.onBlockSelect(b)
    }, _onBlockDeselect: function (b) {
        var f = _.find(this.instances, function (g) {
            return g.id === b.originalEvent.detail.sectionId
        });
        !_.isUndefined(f) && _.isFunction(f.onBlockDeselect) && f.onBlockDeselect(b)
    }, register: function (b, f) {
        this.constructors[b] = f, $('[data-section-type=' + b + ']').each(function (g, j) {
            this._createInstance(j, f)
        }.bind(this))
    }
}), theme.Sliders = function () {
    function b(f) {
        var g = this.$container = $(f), j = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.sliderId = $('#shopify-section-' + j), this.sliderNamspace = '#home-slider-' + j, this.countdownHolder = $('.count_holder_small-' + j), this.sliderWrapper = $('#slideshow_wrapper-' + j), this.slider = $('#home-slider-' + j), this.sliderTxt = '#home-slider-' + j, this.sliderCamera = $('#home-camera-slider-' + j), this.sliderOverlay = $('#home-slider-overlay-' + j), this.countdownHolder = $('.count_holder_small-' + j), this.options = {
            show_slideshow: $('#slideshow_wrapper-' + j).data('show_slideshow'),
            slideshow_auto: $('#slideshow_wrapper-' + j).data('slideshow_auto'),
            show_slideshow_dots: $('#slideshow_wrapper-' + j).data('show_slideshow_dots'),
            slideshow_interval: $('#slideshow_wrapper-' + j).data('slideshow_interval')
        }, this._handleSlideshow()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _handleSlideshow: function () {
            if (sliderOverlay = this.sliderOverlay, this.slider.length) switch (this.options.show_slideshow) {
                case'camera':
                    this.sliderCamera.camera({
                        loader: 'none',
                        imagePath: window.blank_gif,
                        autoAdvance: this.options.slideshow_auto,
                        mobileAutoAdvance: this.options.slideshow_auto,
                        pagination: this.options.show_slideshow_dots,
                        thumbnails: !1,
                        playPause: !1
                    }), imagesLoaded(this.sliderTxt, function () {
                        sliderOverlay.hide()
                    });
                    break;
                case'responsive':
                    this.slider.responsiveSlider({
                        autoplay: this.options.slideshow_auto,
                        interval: this.options.slideshow_interval,
                        transitionTime: 300
                    }), imagesLoaded(this.sliderTxt, function () {
                        sliderOverlay.hide()
                    });
                    break;
                case'flexslider':
                    this.slider.flexslider({
                        animation: 'fade',
                        prevText: 'previous',
                        nextText: 'next',
                        slideshowSpeed: this.options.slideshow_interval,
                        slideshow: this.options.slideshow_auto,
                        controlNav: this.options.show_slideshow_dots,
                        start: function () {
                            $('body').removeClass('loading')
                        }
                    }), imagesLoaded(this.sliderTxt, function () {
                        sliderOverlay.hide()
                    });
            }
            this._countdown(), this.slider.length && (this._mockupCaptionSlider(), this._resizeFontSize())
        }, _countdown: function () {
            var f = new Date;
            !$('html').hasClass('ie8') && this.countdownHolder.length && this.countdownHolder.each(function () {
                var g = $(this).data('slide_expires').split('-'), g = new Date(g[2], parseInt(g[0]) - 1, g[1]);
                f < g ? $(this).children().countdown({until: g}) : $(this).hide()
            })
        }, _resizeFontSize: function () {
            var f = this.slider, g = this.sliderTxt;
            $(window).resize(function () {
                f.length && $(g + ' .home-slide-item').length && $(g + ' .home-slide-item').each(function () {
                    var j = $(this).data('slide_id'), k = $(this).data('general_font_size'),
                        l = $(this).data('slide_heading_size'), m = $(this).data('slide_caption_size'),
                        n = roar.getWidthBrowser(), q = l * n / 1200, r = m * n / 1200;
                    1200 > roar.getWidthBrowser() ? (k > q && (q = k), k > r && (r = k), $(j + ' .slide_caption .caption-content').css({'font-size': r}), $(j + ' .slide_heading .caption-content').css({'font-size': q})) : ($(j + ' .slide_caption .caption-content').css({'font-size': m}), $(j + ' .slide_heading .caption-content').css({'font-size': l}))
                })
            })
        }, _mockupCaptionSlider: function () {
            var f = this.sliderTxt;
            this.slider.length && $(f + ' .home-slide-item').length && $(f + ' .home-slide-item').each(function () {
                var g = $(this).data('slide_id'), j = $(this).data('general_font_size'),
                    k = $(this).data('slide_heading_size'), l = $(this).data('slide_caption_size'),
                    m = roar.getWidthBrowser(), n = k * m / 1200, q = l * m / 1200;
                1200 > roar.getWidthBrowser() ? (j > n && (n = j), j > q && (q = j), $(g + ' .slide_caption .caption-content').css({'font-size': q}), $(g + ' .slide_heading .caption-content').css({'font-size': n})) : ($(g + ' .slide_caption .caption-content').css({'font-size': l}), $(g + ' .slide_heading .caption-content').css({'font-size': k}))
            })
        }, onUnload: function () {
            this.$container.off(this.sliderNamspace)
        }, onSelect: function () {
        }, onBlockSelect: function () {
        }, onBlockDeselect: function () {
        }
    }), b
}();

function onYouTubeIframeAPIReady() {
    theme.YouTubeVideos.loadVideos()
}

theme.YouTubeVideos = function () {
    function k(z) {
        return v[z.target.h.id]
    }

    function l() {
        $('.home_video_bg').each(function (z, A) {
            m($(A))
        })
    }

    function m(z) {
        var A = z.closest('.home-video'), B = z, C = A.width(), D = A.height(), E = B.width(), F = B.height();
        C / y.ratio < F ? (E = Math.ceil(F * y.ratio), z.width(E).height(F).css({
            left: (C - E) / 2,
            top: 0
        })) : (F = Math.ceil(C / y.ratio), z.width(C).height(F).css({
            left: 0,
            top: (F - F) / 2
        })), A.height(F), z.addClass('home_video_loaded')
    }

    function r() {
        $(window).on('resize.videoPlayer', $.debounce(250, function () {
        }))
    }

    var u = !1, v = {}, x = [], y = {
        ratio: 16 / 9,
        playerVars: {
            modestbranding: 1,
            autoplay: 1,
            controls: 0,
            showinfo: 0,
            branding: 0,
            rel: 0,
            autohide: 1,
            cc_load_policy: 1,
            disablekb: 0,
            fs: 1,
            iv_load_policy: 3,
            start: 0,
            end: 0,
            loop: 1,
            rel: 0
        },
        events: {
            onReady: function (z) {
                var A = k(z);
                A.playerId.addClass('home_video_bg'), z.target.setPlaybackQuality('hd1080'), z.target.mute(), z.target.setLoop(!0), l()
            }, onStateChange: function (z) {
                var A = k(z);
                switch (z.data) {
                    case 0:
                        x[A.id].seekTo(A.playerVars.start);
                        break;
                    case 1:
                        break;
                    case 2:
                }
            }
        }
    };
    return {
        init: function (z) {
            if (z.id && (v[z.id] = {
                id: z.id,
                playerId: z.player_id,
                videoId: z.video_id,
                homeVideo: z.home_video,
                videoSelector: z.id,
                playerVars: z.playerDefaults
            }, !u)) {
                var A = document.createElement('script');
                A.src = 'https://www.youtube.com/iframe_api';
                var B = document.getElementsByTagName('script')[0];
                B.parentNode.insertBefore(A, B)
            }
        }, loadVideos: function () {
            for (var E in v) if (v.hasOwnProperty(E)) {
                var F = $.extend({}, y, v[E]);
                console.log(v[E]), F.playerId.addClass('home_video_bg'), console.log(F), x[E] = new YT.Player(E, F)
            }
            l(), r(), u = !0
        }, loadVideo: function (z) {
            if (u) {
                var A = $.extend({}, y, v[z]);
                x[z] = new YT.Player(z, A), r()
            }
        }
    }
}(), theme.Videos = function () {
    function b(f) {
        var g = this.$container = $(f), j = this.sectionId = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.videoId = $('#shopify-section-' + j), this.videoNamspace = '#home-video-' + j, this.VideoHomeId = $(this.videoNamspace), this.PlayerNamespace = 'playerYoutube-' + j, this.PlayerId = $('#playerYoutube-' + j), this.VideoHomeCaption = $(this.videoNamspace + ' .video_caption'), this.VideoHomeHeading = $(this.videoNamspace + ' .video_heading'), this.VideoHomeWidth = $(this.videoNamspace + ' .video_width'), this.options = {
            general_font_size: this.VideoHomeId.data('general_font_size'),
            video_heading_size: this.VideoHomeId.data('video_heading_size'),
            video_caption_size: this.VideoHomeId.data('video_caption_size'),
            video_type: this.VideoHomeId.data('video_type')
        }, this.video_start = this.VideoHomeId.data('video_start');
        var l = this.VideoHomeId.data('video_duration');
        this.video_end = parseInt(this.video_start) + parseInt(l), this._mockupCaptionVideo(), 'yt-video' == this.options.video_type && this._handleYoutubeVideo()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _handleYoutubeVideo: function () {
            var f = {
                id: this.PlayerNamespace,
                video_id: this.PlayerId.data('video_id'),
                home_video: this.VideoHomeId,
                player_id: this.PlayerId,
                playerDefaults: {
                    modestbranding: 1,
                    autoplay: 1,
                    controls: 0,
                    showinfo: 0,
                    branding: 0,
                    rel: 0,
                    autohide: 1,
                    start: this.video_start,
                    end: this.video_end
                }
            };
            window.home_video_list[f.id] = f, theme.YouTubeVideos.init(f), theme.YouTubeVideos.loadVideo(f.id)
        }, _mockupCaptionVideo: function () {
            if (this.VideoHomeId.length) if (1200 > roar.getWidthBrowser()) {
                var f = this.options.general_font_size, g = this.options.video_heading_size,
                    j = this.options.video_caption_size, k = roar.getWidthBrowser(), l = g * k / 1200, m = j * k / 1200;
                f > l && (l = f), f > m && (m = f), this.VideoHomeCaption.css({'font-size': m}), this.VideoHomeHeading.css({'font-size': l})
            } else {
                var g = this.options.video_heading_size, j = this.options.video_caption_size;
                this.VideoHomeCaption.css({'font-size': j}), this.VideoHomeHeading.css({'font-size': g})
            }
            this._resizeFontSize()
        }, _resizeFontSize: function () {
            var f = this.VideoHomeId, g = this.VideoHomeHeading, j = this.VideoHomeCaption;
            general_font_size = this.options.general_font_size, video_heading_size = this.options.video_heading_size, video_caption_size = this.options.video_caption_size, $(window).resize(function () {
                if (f.length) if (1200 > roar.getWidthBrowser()) {
                    var k = general_font_size, l = video_heading_size, m = video_caption_size,
                        n = roar.getWidthBrowser(), q = l * n / 1200, r = m * n / 1200;
                    k > q && (q = k), k > r && (r = k), j.css({'font-size': r}), g.css({'font-size': q})
                } else {
                    var l = video_heading_size, m = video_caption_size;
                    j.css({'font-size': m}), g.css({'font-size': l})
                }
            })
        }, onUnload: function () {
            this.$container.off(this.videoNamspace)
        }, onSelect: function () {
        }, onBlockSelect: function () {
        }, onBlockDeselect: function () {
        }
    }), b
}(), theme.SingleProduct = function () {
    function b(f) {
        var g = this.$container = $(f), j = this.sectionId = g.attr('data-section-id');
        this.selectors = {
            gallery_main_id: '#gallery_main-' + j,
            gallery_main: 'gallery_main-' + j,
            main_image: '#product-image-' + j + ' .main-image',
            image_thumb: '#product-image-' + j + ' .image-thumb',
            fancybox: '#product-image-' + j + ' .section_fancybox',
            product_image: '#product-image-' + j,
            product_image_wrapper: '.product-image-wrapper',
            main_image_bg: '.product-image-' + j + ' .main-image .main-image-bg',
            elevatezoom: '#product-image-' + j + ' .elevatezoom',
            img_zoom: '#product-image-' + j + ' .elevatezoom .img-zoom',
            img_thumb: '#product-image-' + j + ' .image-thumb'
        }, this._handleImageThumbs(), this._alwaysRefreshZoom()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _alwaysRefreshZoom: function () {
            var f = this.selectors.img_zoom, g = this.selectors.elevatezoom, j = this.selectors.gallery_main;
            if (0 == roar.touch && ('zoom' == window.main_image_display || 'both' == window.main_image_display) && $(g).length) {
                var k = $(f);
                k.elevateZoom({
                    gallery: j,
                    galleryActiveClass: 'active',
                    zoomType: 'window',
                    cursor: 'pointer',
                    zoomWindowFadeIn: 300,
                    zoomWindowFadeOut: 300,
                    scrollZoom: !1,
                    easing: !0,
                    loadingIcon: window.loader_gif
                }), 'both' == window.main_image_display && $(f).bind('click', function () {
                    var m = $('.elevatezoom .img-zoom').data('elevateZoom');
                    return $.fancybox(m.getGalleryList(), {closeBtn: !1, helpers: {buttons: {}}}), !1
                })
            }
        }, _handleImageThumbs: function () {
            var f = this.selectors.img_thumb;
            $(this.selectors.gallery_main_id).length && (roar.touch ? $(this.selectors.main_image).on('click', function () {
                var g = [], j = 0, k = $(image_thumb);
                return k.each(function (l, m) {
                    g.push({href: m.href, title: m.title}), $(this).hasClass('active') && (j = l)
                }), $.fancybox(g, {
                    closeBtn: !1,
                    index: j,
                    openEffect: 'none',
                    closeEffect: 'none',
                    nextEffect: 'none',
                    prevEffect: 'none',
                    helpers: {buttons: {}}
                }), !1
            }) : 'lightbox' == window.main_image_display && $(this.selectors.fancybox).on(roar.clickEv, function () {
                var g = [], j = 0, k = $(f);
                return k.each(function (l, m) {
                    g.push({href: m.href, title: m.title}), $(this).hasClass('active') && (j = l)
                }), $.fancybox(g, {closeBtn: !1, index: j, helpers: {buttons: {}}}), !1
            }), $('#product-image-' + this.sectionId).on('click', '.image-thumb', function () {
                var g = $(this);
                if (!g.hasClass('active')) {
                    var j = g.parents('.product-image'), k = g.attr('data-image-zoom'), l = g.attr('data-image');
                    j.find('.image-thumb').removeClass('active'), g.addClass('active'), j.find('.main-image').find('img').attr('data-zoom-image', k), j.find('.main-image').find('img').attr('src', l).load(function () {
                    })
                }
                return !1
            }))
        }, onUnload: function () {
            this.$container.off(this.Oneproductnamespace)
        }, onSelect: function () {
        }, onBlockSelect: function () {
        }, onBlockDeselect: function () {
        }
    }), b
}(), theme.FeaturedCollections = function () {
    function b(f) {
        var g = this.$container = $(f), j = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.featuredCollection = $('#featured-collections-' + j), this.featuredCollectionNamespace = '#featured-collections-' + j, this.featuredCollectionId = $('#shopify-section-' + j), this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
            $('.featured-collections-child').each(function () {
                if ($(this).hasClass('collection_odd')) var f = 4; else var f = 2;
                $(this).owlCarousel({
                    navigation: !0,
                    pagination: !1,
                    mouseDrag: !1,
                    lazyLoad: !0,
                    items: f,
                    itemsDesktop: [1199, f],
                    itemsDesktopSmall: [991, 3],
                    itemsTablet: [768, 3],
                    itemsTabletSmall: [767, 2],
                    itemsMobile: [479, 1],
                    scrollPerPage: !0,
                    navigationText: ['<span class="btn medium"><i class="fa fa-angle-left"></i></span>', '<span class="btn medium"><i class="fa fa-angle-right"></i></span>']
                })
            })
        }, onUnload: function () {
            this.$container.off(this.featuredCollectionNamespace)
        }, onSelect: function () {
        }, onBlockSelect: function () {
        }, onBlockDeselect: function () {
        }
    }), b
}(), theme.SpecialOffers = function () {
    function b(f) {
        var g = this.$container = $(f), j = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.specialOffer = $('#special-offers-' + j), this.specialOfferNamspace = '#special-offers-' + j, this.specialOfferId = $('#shopify-section-' + j);
        this.options = {
            navigation: !0,
            pagination: !1,
            mouseDrag: !1,
            items: 3,
            itemsDesktop: [1199, 3],
            itemsDesktopSmall: [991, 3],
            itemsTablet: [768, 3],
            itemsTabletSmall: [767, 2],
            itemsMobile: [479, 1],
            scrollPerPage: !1,
            navigationText: ['<span class="btn medium"><i class="fa fa-angle-left"></i></span>', '<span class="btn medium"><i class="fa fa-angle-right"></i></span>']
        };
        this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
            this.specialOffer.owlCarousel(this.options)
        }, onUnload: function () {
            this.$container.off(this.specialOfferNamspace)
        }, onSelect: function () {
        }, onBlockSelect: function () {
        }, onBlockDeselect: function () {
        }
    }), b
}(), theme.Partners = function () {
    function b(f) {
        var g = this.$container = $(f), j = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.ourPartner = $('#our-partner-' + j), this.ourPartnerNamspace = '#our-partner-' + j, this.ourPartnerId = $('#shopify-section-' + j);
        this.options = {
            navigation: !0,
            pagination: !1,
            mouseDrag: !1,
            items: 5,
            itemsDesktop: [1199, 5],
            itemsDesktopSmall: [991, 4],
            itemsTablet: [768, 3],
            itemsTabletSmall: [767, 3],
            itemsMobile: [479, 1],
            scrollPerPage: !1,
            navigationText: ['<span class="btn medium"><i class="fa fa-angle-left"></i></span>', '<span class="btn medium"><i class="fa fa-angle-right"></i></span>']
        };
        this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
            this.ourPartner.length && this.ourPartner.owlCarousel(this.options)
        }, onUnload: function () {
            this.$container.off(this.ourPartnerNamspace)
        }, onSelect: function () {
        }, onBlockSelect: function () {
        }, onBlockDeselect: function () {
        }
    }), b
}(), theme.FeaturedProducts = function () {
    function b(f) {
        var g = this.$container = $(f), j = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.featuredProduct = $('#featured-products-' + j), this.featuredProductNamspace = '#featured-products-' + j, this.featuredProductId = $('#shopify-section-' + j), this.featured_products_home_style = this.featuredProduct.data('featured_products_home_style'), this.featured_products_home_scroll = this.featuredProduct.data('featured_products_home_scroll'), this.options = {
            navigation: !0,
            pagination: !1,
            mouseDrag: !1,
            items: 4,
            itemsDesktop: [1199, 4],
            itemsDesktopSmall: [991, 3],
            itemsTablet: [768, 3],
            itemsTabletSmall: [767, 2],
            itemsMobile: [479, 1],
            scrollPerPage: this.featured_products_home_scroll,
            navigationText: ['<span class="btn medium"><i class="fa fa-angle-left"></i></span>', '<span class="btn medium"><i class="fa fa-angle-right"></i></span>']
        }, this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
            this.featuredProduct.length && 'carousel' == this.featured_products_home_style && this.featuredProduct.owlCarousel(this.options)
        }, onUnload: function () {
            this.$container.off(this.featuredProductNamspace)
        }, onSelect: function () {
        }, onBlockSelect: function () {
        }, onBlockDeselect: function () {
        }
    }), b
}(), theme.ContactMap = function () {
    function b(f) {
        var g = this.$container = $(f), j = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.contactMap = $('#contact_map-' + j), this.contactMapNamspace = '#contact_map-' + j, this.contactMapId = $('#shopify-section-' + j), this.contact_address = window.contact_address, this.contact_icon = window.contact_icon, 'manual' == this.contactMap.data('address_type') && (this.contact_address = this.contactMap.data('contact_address')), this.contact_zoom = this.contactMap.data('contact_zoom'), this.contact_scroll = this.contactMap.data('contact_scroll'), this.contact_type = this.contactMap.data('contact_type'), this.home_contact_map_placement = this.contactMap.data('home_contact_map_placement'), this.options = {
            zoom: this.contact_zoom,
            scrollwheel: this.contact_scroll,
            maptype: this.contact_type,
            markers: [{
                address: this.contact_address,
                html: '_address',
                icon: {image: this.contact_icon, iconsize: [188, 68], iconanchor: [0, 68]}
            }]
        }, this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
            'within-container' == this.home_contact_map_placement && this.contactMapId.addClass('container'), this.contactMap.length && jQuery().gMap && this.contactMap.gMap(this.options)
        }, onUnload: function () {
            this.$container.off(this.contactMapNamspace)
        }, onSelect: function () {
        }, onBlockSelect: function () {
        }, onBlockDeselect: function () {
        }
    }), b
}(), theme.feedback = function () {
    function b(f) {
        var g = this.$container = $(f), j = this.sectionId = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.feedbackId = $('#shopify-section-' + j), this.feedback = $('#feedback-wrapper-' + j), this.feedbackNamspace = '#feedback-wrapper-' + j, this.trans_submit_waiting = this.feedback.data('trans_submit_waiting'), this.trans_submit_button = this.feedback.data('trans_submit_button'), this.trans_error_text = this.feedback.data('trans_error_text'), this.trans_thank_you_text = this.feedback.data('trans_thank_you_text'), this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
            var f = this.sectionId, g = this.trans_submit_waiting, j = this.trans_submit_button,
                k = this.trans_error_text, l = this.trans_thank_you_text;
            jQuery('#feedback_submit-' + f).click(function () {
                var m = !1;
                if (jQuery('#feedback_email-' + f).val() ? jQuery('#feedback_email-' + f).parent().removeClass('error') : (jQuery('#feedback_email-' + f).parent().addClass('error'), m = !0), jQuery('#feedback_message-' + f).val() ? jQuery('#feedback_message-' + f).parent().removeClass('error') : (jQuery('#feedback_message-' + f).parent().addClass('error'), m = !0), m) return !1;
                var n = '/contact?';
                n += encodeURIComponent('form_type') + '=' + encodeURIComponent('contact'), n += '&' + encodeURIComponent('utf8') + '=' + encodeURIComponent('\u2713'), n += '&' + encodeURIComponent('contact[name]') + '=' + encodeURIComponent(jQuery('#feedback_name-' + f).val()), n += '&' + encodeURIComponent('contact[email]') + '=' + encodeURIComponent(jQuery('#feedback_email-' + f).val()), n += '&' + encodeURIComponent('contact[phone]') + '=' + encodeURIComponent(jQuery('#feedback_phone-' + f).val()), n += '&' + encodeURIComponent('contact[body]') + '=' + encodeURIComponent(jQuery('#feedback_message-' + f).val()), jQuery.ajax({
                    type: 'POST',
                    async: !0,
                    url: n,
                    beforeSend: function () {
                        jQuery('#feedback_submit-' + f).val(this.trans_submit_waiting)
                    },
                    error: function () {
                        jQuery('#feedback_submit-' + f).val(j), jQuery('.feedback_notify-' + f).html(k)
                    },
                    success: function () {
                        jQuery('#feedback_submit-' + f).val(j), jQuery('.feedback_notify-' + f).html(l)
                    }
                })
            })
        }, onUnload: function () {
            this.$container.off(this.feedbackNamspace)
        }, onSelect: function () {
        }, onBlockSelect: function () {
        }, onBlockDeselect: function () {
        }
    }), b
}(), theme.newsletter = function () {
    function b(f) {
        var g = this.$container = $(f), j = this.sectionId = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.newsletterId = $('#shopify-section-' + j), this.newsletter = $('#footer-top-' + j), this.newsletterNamspace = '#footer-top-' + j, this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
        }, onUnload: function () {
            this.$container.off(this.newsletterNamspace)
        }
    }), b
}(), theme.instafeedSection = function () {
    function b(f) {
        var g = this.$container = $(f), j = this.sectionId = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.instafeedId = $('#shopify-section-' + j), this.instafeedContent = $('#widget-photos-' + j), this.instafeedNamspace = '#widget-photos-' + j, this.instafeed_list = jQuery('#instagram_list_bottom2-' + j), this.instafeedOptions = {
            limit: this.instafeedContent.data('limit'),
            userId: this.instafeedContent.data('user_id'),
            target: this.instafeedContent.data('target'),
            instagram_token: this.instafeedContent.data('instagram_token')
        }, this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
            var f = this.instafeed_list, g = this.instafeedOptions.limit, j = this.instafeedOptions.target,
                k = this.instafeedOptions.instagram_token, l = this.instafeedOptions.userId,
                m = new Instafeed({
                    get: 'user',
                    target: j,
                    accessToken: k,
                    userId: l,
                    limit: g,
                    resolution: 'low_resolution',
                    resolution2: 'standard_resolution',
                    escapeCaption: true,
                    template: '<a href="{{link}}" rel="{{link}}"><img src="{{image}}" alt="{{caption}}"/></a>',
                    after: function () {
                        f.owlCarousel({
                            navigation: !0,
                            pagination: !1,
                            mouseDrag: !1,
                            items: 4,
                            itemsDesktop: [1199, 4],
                            itemsDesktopSmall: [991, 3],
                            itemsTablet: [768, 3],
                            itemsMobile: [479, 2],
                            scrollPerPage: !1,
                            navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
                        })
                    }
                });
            m.run()
        }, onUnload: function () {
            this.$container.off(this.instafeedNamspace)
        }
    }), b
}(), theme.bottomSection = function () {
    function b(f) {
        var g = this.$container = $(f), j = this.sectionId = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.bottomId = $('#shopify-section-' + j), this.bottom = $('#bottom-wrapper-' + j), this.bottomNamspace = '#bottom-wrapper-' + j, this.socialWidget = this.bottom.find('.widget-socialwidget'), this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
            this._initSocialWidget()
        }, _initSocialWidget: function () {
            this.socialWidget.length && this.socialWidget.each(function () {
                var f = $(this).data('bottom_social_visible'), g = $(this).data('block_id');
                switch (f) {
                    case'instagram':
                        var j = 'instagram_list_bottom-' + g, k = $('#instagram_list_bottom-' + g),
                            l = $(k).data('instagram_token'), m = $(k).data('user_id'),
                            n = $(k).data('instagram_limit'), q = new Instafeed({
                                get: 'user',
                                target: j,
                                accessToken: l,
                                userId: m,
                                limit: n,
                                resolution: 'thumbnail',
                                resolution2: 'standard_resolution'
                            });
                        q.run();
                        break;
                    case'flickr':
                        var j = 'flickr-bottom-' + g, k = $('#flickr-bottom-' + g),
                            r = $('#flickr-bottom-' + g + ' .flickr_fancybox'), u = k.data('flickr_id'),
                            v = k.data('flickr_limit');
                        k.jflickrfeed({
                            limit: v,
                            qstrings: {id: u},
                            itemTemplate: '<li><a class="flickr_fancybox" data-fancybox-group="flickr_button" href="{flickr}image{/flickr}" title="{flickr}title{/flickr}"><img src="{flickr}image_s{/flickr}" alt="{flickr}title{/flickr}" /></a></li>'
                        }, function () {
                            r.fancybox({closeBtn: !1, helpers: {buttons: {}}})
                        });
                        break;
                    case'twitter':
                        !function (x, y, z) {
                            var A, B = x.getElementsByTagName(y)[0], C = /^http:/.test(x.location) ? 'http' : 'https';
                            x.getElementById(z) || (A = x.createElement(y), A.id = z, A.src = C + '://platform.twitter.com/widgets.js', B.parentNode.insertBefore(A, B))
                        }(document, 'script', 'twitter-wjs');
                        break;
                    case'facebook':
                        (function (x, y, z) {
                            var A, B = x.getElementsByTagName(y)[0];
                            x.getElementById(z) || (A = x.createElement(y), A.id = z, A.src = '//connect.facebook.net/en_GB/all.js#xfbml=1', B.parentNode.insertBefore(A, B))
                        })(document, 'script', 'facebook-jssdk');
                        break;
                    default:
                }
            })
        }, onUnload: function () {
            this.$container.off(this.bottomNamspace)
        }
    }), b
}(), theme.photoBoardSection = function () {
    function b(f) {
        var g = this.$container = $(f), j = this.sectionId = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.photoBoardId = $('#shopify-section-' + j), this.photoBoard = $('#photos_board-' + j), this.photoBoardNamspace = '#photo-board-wrapper-' + j, this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
        }, onUnload: function () {
            this.$container.off(this.photoBoardNamspace)
        }
    }), b
}();

function hexToRgbA(b, f) {
    var g;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(b)) return g = b.substring(1).split(''), 3 == g.length && (g = [g[0], g[0], g[1], g[1], g[2], g[2]]), g = '0x' + g.join(''), 'rgba(' + [255 & g >> 16, 255 & g >> 8, 255 & g].join(',') + ',' + f + ')';
    throw new Error('Bad Hex')
}

theme.staticblockSection = function () {
    function b(f) {
        var g = this.$container = $(f), j = this.sectionId = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.staticBlockId = $('#shopify-section-' + j), this.staticBlock = $('#static-surround-' + j), this.staticBlockNamspace = '#static-surround-' + j, this._hex_color = this.staticBlock.data('_hex_color'), this._opacity = this.staticBlock.data('_opacity'), this._rgba = 'rgba(0,0,0,0)' == this._hex_color ? '' : hexToRgbA(this._hex_color, this._opacity), this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
            if ('' != this._rgba) {
                this.staticBlock.find('.static-surround-inner .boxes_content').css('background-color', this._rgba);
                var f = this.staticBlock.find('.static-surround-inner .boxes_content').css('height');
                this.staticBlock.find('.static-surround-inner .boxes_content').each(function () {
                    parseInt(f) < parseInt($(this).css('height')) && (f = $(this).css('height'))
                }), this.staticBlock.find('.static-surround-inner .boxes_content').css('height', f)
            }
        }, onUnload: function () {
            this.$container.off(this.staticBlockNamspace)
        }
    }), b
}(), theme.whiteSpaceSection = function () {
    function b(f) {
        var g = this.$container = $(f), j = this.sectionId = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.whiteSpaceId = $('#shopify-section-' + j), this.whiteSpace = $('#white-space-' + j), this.whiteSpaceNamspace = '#white-space-' + j, this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
        }, onUnload: function () {
            this.$container.off(this.whiteSpaceNamspace)
        }
    }), b
}(), theme.homeProductSection = function () {
    function b(f) {
        var g = this.$container = $(f), j = this.sectionId = g.attr('data-section-id'), k = g.attr('data-section-type');
        this.homeProductId = $('#shopify-section-' + j), this.homeProduct = $('#home-product-' + j), this.homeProductNamspace = '#home-product-' + j, this._init()
    }

    return b.prototype = _.assignIn({}, b.prototype, {
        _init: function () {
            this._initCountdown()
        }, _initCountdown() {
            0 < $('.home_product_countdown').length && $('.home_product_countdown').each(function () {
                var f = parseInt($(this).data('offer_date_year')), g = parseInt($(this).data('offer_date_month')),
                    j = parseInt($(this).data('offer_date_day')), k = new Date, l = new Date(f, j - 1, g);
                k < l ? $(this).countdown({until: l}) : $(this).hide()
            })
        }, onUnload: function () {
            this.$container.off(this.homeProductNamspace)
        }
    }), b
}(), $(document).ready(function () {
    var b = new theme.Sections;
    b.register('home-slider', theme.Sliders), b.register('home-video', theme.Videos), b.register('one-product', theme.SingleProduct), b.register('featured-collections', theme.FeaturedCollections), b.register('featured-products', theme.FeaturedProducts), b.register('special-offers', theme.SpecialOffers), b.register('partners', theme.Partners), b.register('contact-map', theme.ContactMap), b.register('feedback', theme.feedback), b.register('newsletter', theme.newsletter), b.register('static-block', theme.staticblockSection), b.register('instafeed-section', theme.instafeedSection), b.register('bottom-section', theme.bottomSection), b.register('photos-board', theme.photoBoardSection), b.register('white-space', theme.whiteSpaceSection), b.register('home-product', theme.homeProductSection)
});